export default "__VITE_ASSET__B2LpyQ36__"